import {
    Button,
    Typography
} from "@mui/material";
import React from "react";
import classes from "./OperationGroup.module.scss";

const OperationGroup = React.memo(({ title, lable, onClick, endIcon, buttonText, disabled = false }) => {

    return (
        <section className={classes.boxGrid}>
            <article className={classes.boxSubGrid}>
                <Typography className={classes.boxTitle} >{title}</Typography>
                <Typography className={classes.boxLabel} variant='body2'>{lable}</Typography>
            </article>
            <Button
                disabled={disabled}
                className={classes.boxButton}
                disableRipple={true}
                variant="outlined" onClick={onClick} endIcon={endIcon}>
                {buttonText}
            </Button>
        </section>
    );
});

export default OperationGroup;
